import styled, { css } from 'styled-components';

export const Element = styled.div`
  ${({ theme, ...props }) => {
    return css`
      text-align: center;
      margin-bottom: 0;
      margin-top: auto;
    `;
  }};
`;
